import React from 'react';
import classNames from 'classnames';
import { Icon } from 'rhombus-react';

import './DynamicToggle.css';

export default function DynamicToggle(props){
	const {
		onClick,
		tip,
		isDynamic,
		isDisabled,
	} = props;

	const className = classNames({
		"dynamic-toggle": true,
		"is-dynamic": isDynamic,
		disabled: isDisabled,
	});

	const handleClick = (event) => {
		if (isDisabled) {
			return;
		}
		onClick(event);
	};

	return (
		<div className={className} onClick={handleClick} data-tip={tip} data-multiline>
			<Icon name="fas fa-bolt" />
		</div>
	);
}

DynamicToggle.displayName = "DynamicToggle";

DynamicToggle.defaultProps = {
	isDynamic: false,
	isDisabled: false,
};
